import { useState, useEffect } from 'react';
import { Card, Tooltip, Tag, } from 'antd';
import { APIClient } from '../../helpers/api_helper';
import Breadcrumb from '../../Common/Breadcrumb';
import utils from '../../Common/utils';
import MergeModal from '../../Common/MergeModal';
import ProjectTypeDrawer from '../../Common/ProjectTypeDrawer';
import { Pagination, Table, Button, Space} from 'antd';
import {PlusOutlined} from '@ant-design/icons';
import {EditFilled, MergeCellsOutlined} from '@ant-design/icons';
import { useSelector, useDispatch } from "react-redux";
import { setInitialFilterConf, updateFilterData } from '../../slices/filters/thunk'
import { loadProjectTypes as reloadProjectTypesGlobal } from '../../slices/thunk';


const api = new APIClient();


const ProjectTypesList = () => {
  document.title = "Vrste projektov" + process.env.REACT_APP_PAGE_TITLE;

  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const filterdata = useSelector((state) => state.Filterdata.data)
  const searchPending = useSelector((state) => state.Filterdata.searchPending)
  const [editedId, setEditedId] = useState(null);
  const [open, setOpen] = useState(false);
  const [mergeModalOpen, setMergeModalOpen] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    dispatch(setInitialFilterConf({
      data: {},
      // Only the normal search box.
      hidden: ['relateds_group', 'intent_type', 'intent_checkboxes_group', 'dt_range'],
      disabled: []
    }))
  }, []);


  const loadProjects = () => {
    setLoading(true);
    api.get('/api/project_types/', filterdata)
      .then((resp) => setData(resp))
      .finally(() => setLoading(false));
  }

  const onEdit = (id) => {
    setEditedId(id)
    setOpen(true);
  }


  const columns = [
    {title: 'Naziv', dataIndex: 'title'},
    {title: 'Število projektov', dataIndex: 'projects_count'},
    {title: 'Uredi', key: 'edit', render: r => <Button size='small' onClick={() => onEdit(r.id)}><EditFilled/></Button>}
  ]


  useEffect(() => {
      loadProjects()
  }, [filterdata]);


  return (
    <>
      <ProjectTypeDrawer
        open={open}
        onCancel={() => {
          setOpen(false);
          setEditedId(null);
        }}
        onDone={() => {
          loadProjects(filterdata);
          setEditedId(null);
          setOpen(false);
        }}
        id={editedId}
      />

      <MergeModal
        open={mergeModalOpen}
        title='Združevanje vrst projektov'
        mergeApiUrl={"/api/project_types/merge/"}
        mergeInfoApiUrl={"/api/project_types/merge_info/"}
        items={data?.results?.filter(x => selectedIds.includes(x.id))}
        onCancel={() => setMergeModalOpen(false)}
        onDone={() => {
          loadProjects(filterdata);
          dispatch(reloadProjectTypesGlobal());
          setMergeModalOpen(false);
        }}
      />

      <Breadcrumb parentTitle="Šifranti" pageTitle="Vrste projektov" />

      <Card
        title='Vrste projektov'
        extra={
          <Space>
            <Tooltip title={'Izberite vrste projektov za združevanje!'}>
              <Button
                disabled={selectedIds.length === 0}
                onClick={() => setMergeModalOpen(true)}
                icon={<MergeCellsOutlined />}
              />
            </Tooltip>
            <Button
              onClick={ev => {
                setEditedId(null)
                setOpen(true)
              }}
              icon={<PlusOutlined />}
            />
         </Space>
        }
      >
        <Table
            size="small"
            loading={loading || searchPending}
            columns={columns}
            dataSource={data?.results || []}
            pagination={false}
            rowKey={obj => obj.id}
            rowSelection={{ onChange: (ids) => setSelectedIds(ids) }}
            rowClassName={(record) => {}}
        />
        <Pagination
            current={filterdata.page}
            onChange={pInx => dispatch(updateFilterData({page: pInx}))}
            showSizeChanger={false}
            {...utils.processPagination(data?.pagination)}
        />
      </Card>
    </>
  )
}

export default ProjectTypesList;
